export default __webpack_public_path__ + "static/media/block.f8d5db25.svg";